<template>
    <section class="new-cadence-information d-flex flex-row justify-content-center py-3">
        <p> Szanowni Państwo, "Kreator nowej kadencji" jest już dostępny, aby zapoznać się z instrukcją <span style="font-weight: bold; text-decoration: underline; cursor: pointer;" @click="goToInstruction()">KLIKNIJ TUTAJ</span>, aby rozpocząć procedurę tworzenia nowej kadencji <span style="font-weight: bold; text-decoration: underline; cursor: pointer;" ><router-link :to="{name: 'NewCadenceWizards'}">KLIKNIJ TUTAJ</router-link></span>&nbsp;</p>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "NewCadenceLink",
        methods: {
            goToInstruction() {
                window.open('https://pomoc.mwc.pl/kreator/', '_blank');
            }
        }
    }
</script>
<style lang="scss">
    .new-cadence-information {
        background: #ffd9d9;
        //margin-top: 5px;
        font-size: 14px;
        text-align: center;
    }
</style>